import { Cartesian3, Cartographic } from "cesium";
import { SerializableCartographic } from "../models/serializable-cartographic";

export function convertSerializableCartographicToCartesian3(cartographicDegrees: SerializableCartographic): Cartesian3 {
    const cartographic = Cartographic.fromDegrees(cartographicDegrees.longitude, cartographicDegrees.latitude, cartographicDegrees.height);

    return Cartographic.toCartesian(cartographic);
}
